export const LINK = {
  twitter: "https://twitter.com/jjug",
  facebook: "https://www.facebook.com/japanjug/",
  doorKeeper: "https://jjug.doorkeeper.jp/",
  officialSite: "http://www.java-users.jp/",
  register: "https://jjug.doorkeeper.jp/events/112842",
}
